/* eslint-disable max-len */
import { SvgProps } from './types'

export const CalendarIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M29.8138 6.53284H35.0973C36.1475 6.53284 37.0014 7.38315 37.0014 8.43695V36.5989C37.0014 37.649 36.1511 38.503 35.0973 38.503H4.90411C3.85394 38.503 3 37.6527 3 36.5989V8.43695C3 7.38678 3.85031 6.53284 4.90411 6.53284H10.1877"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0416 6.53284H13.9629"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.00391 14.3164H37.0017"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0372 10.5663C11.1251 10.5663 10.3838 9.82503 10.3838 8.91295V4.15631C10.3838 3.24422 11.1251 2.50293 12.0372 2.50293C12.9492 2.50293 13.6905 3.24422 13.6905 4.15631V8.91295C13.6905 9.82503 12.9492 10.5663 12.0372 10.5663Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9639 10.5663C27.0518 10.5663 26.3105 9.82503 26.3105 8.91295V4.15631C26.3105 3.24422 27.0518 2.50293 27.9639 2.50293C28.876 2.50293 29.6173 3.24422 29.6173 4.15631V8.91295C29.6173 9.82503 28.876 10.5663 27.9639 10.5663Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5568 21.7039C24.5843 21.7039 25.4173 20.8709 25.4173 19.8434C25.4173 18.8159 24.5843 17.9829 23.5568 17.9829C22.5293 17.9829 21.6963 18.8159 21.6963 19.8434C21.6963 20.8709 22.5293 21.7039 23.5568 21.7039Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6642 21.6241C31.6917 21.6241 32.5247 20.7911 32.5247 19.7636C32.5247 18.7361 31.6917 17.9031 30.6642 17.9031C29.6367 17.9031 28.8037 18.7361 28.8037 19.7636C28.8037 20.7911 29.6367 21.6241 30.6642 21.6241Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4494 21.7039C17.4769 21.7039 18.3099 20.8709 18.3099 19.8434C18.3099 18.8159 17.4769 17.9829 16.4494 17.9829C15.4218 17.9829 14.5889 18.8159 14.5889 19.8434C14.5889 20.8709 15.4218 21.7039 16.4494 21.7039Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5568 28.1175C24.5843 28.1175 25.4173 27.2845 25.4173 26.257C25.4173 25.2295 24.5843 24.3965 23.5568 24.3965C22.5293 24.3965 21.6963 25.2295 21.6963 26.257C21.6963 27.2845 22.5293 28.1175 23.5568 28.1175Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6642 28.0377C31.6917 28.0377 32.5247 27.2047 32.5247 26.1772C32.5247 25.1496 31.6917 24.3167 30.6642 24.3167C29.6367 24.3167 28.8037 25.1496 28.8037 26.1772C28.8037 27.2047 29.6367 28.0377 30.6642 28.0377Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4494 28.1175C17.4769 28.1175 18.3099 27.2845 18.3099 26.257C18.3099 25.2295 17.4769 24.3965 16.4494 24.3965C15.4218 24.3965 14.5889 25.2295 14.5889 26.257C14.5889 27.2845 15.4218 28.1175 16.4494 28.1175Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.34097 28.1175C10.3685 28.1175 11.2015 27.2845 11.2015 26.257C11.2015 25.2295 10.3685 24.3965 9.34097 24.3965C8.31345 24.3965 7.48047 25.2295 7.48047 26.257C7.48047 27.2845 8.31345 28.1175 9.34097 28.1175Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5568 34.5313C24.5843 34.5313 25.4173 33.6983 25.4173 32.6708C25.4173 31.6433 24.5843 30.8103 23.5568 30.8103C22.5293 30.8103 21.6963 31.6433 21.6963 32.6708C21.6963 33.6983 22.5293 34.5313 23.5568 34.5313Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4494 34.5313C17.4769 34.5313 18.3099 33.6983 18.3099 32.6708C18.3099 31.6433 17.4769 30.8103 16.4494 30.8103C15.4218 30.8103 14.5889 31.6433 14.5889 32.6708C14.5889 33.6983 15.4218 34.5313 16.4494 34.5313Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.34097 34.5312C10.3685 34.5312 11.2015 33.6982 11.2015 32.6707C11.2015 31.6432 10.3685 30.8102 9.34097 30.8102C8.31345 30.8102 7.48047 31.6432 7.48047 32.6707C7.48047 33.6982 8.31345 34.5312 9.34097 34.5312Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
